import { render, staticRenderFns } from "./Aviso-de-privacidad.vue?vue&type=template&id=308f0e65&scoped=true&"
import script from "./Aviso-de-privacidad.vue?vue&type=script&lang=js&"
export * from "./Aviso-de-privacidad.vue?vue&type=script&lang=js&"
import style0 from "./Aviso-de-privacidad.vue?vue&type=style&index=0&id=308f0e65&scoped=true&lang=css&"
import style1 from "./Aviso-de-privacidad.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f0e65",
  null
  
)

export default component.exports